export var searchLink = '/help/search/';
export var phoneNumbers = {
  annualCreditReport: '1-877-322-8228',
  experianSmartMoneyCustomerServiceTollFree: '(833) 804-0770',
  experianSmartMoneyCustomerServiceInternational: '+1 (479) 343-6242',
  expContact: '1-888-397-3742',
  expLettersPhone: '1-888-EXPERIAN',
  equifax: '1-800-685-1111',
  transunion: '1-888-909-8872',
  equifaxFraud: '1-800-525-6285',
  transunionFraud: '1-800-680-7289'
};